// extracted by mini-css-extract-plugin
export default {"page":"Homepage_page__oksa8","title_box":"Homepage_title_box__MoTgr","subtitle":"Homepage_subtitle__yFI2m"};